import { Currency, ETHER, Token } from 'etndswap-sdk'

export function currencyId(currency: Currency): string {
  if (currency === ETHER) return 'ETND'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
